import React from 'react';
import { Image } from 'components/Image/Image';
import { TextV2 } from 'components/TextV2/TextV2';
import { useTranslation } from 'react-i18next';
import styles from './BackButton.module.scss';

export interface IBackButtonProps {
  isVisible?: boolean;
  onBackButtonClick: (event: React.UIEvent) => void;
}
export const BackButton: React.FC<IBackButtonProps> = ({ isVisible, onBackButtonClick }) => {
  const { t } = useTranslation();

  if (!isVisible) {
    return null;
  }

  const onClick: React.MouseEventHandler = onBackButtonClick;

  return (
    <div className={styles.container}>
      <button type="button" onClick={onClick} className={styles.backButton}>
        <Image className={styles.backButtonIcon} aria-hidden />
        <TextV2 tagName="p" variant="body" value={t('back')} className={styles.backButtonText} />
      </button>
    </div>
  );
};
